import { memo } from "react";
import { FeaturedIcon, FeaturedIconProps } from "../../../MiscIcons";

import { ReactComponent as InfoIcon } from "./icons/info.svg";

type AlertCircleIconProps = Omit<FeaturedIconProps, "children">;

export const AlertInfoSquareIcon = memo<AlertCircleIconProps>(props => {
  return (
    <FeaturedIcon type="modern" size="md" {...props}>
      <InfoIcon />
    </FeaturedIcon>
  );
});
